//
//
//
//

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'TaskDescription',
  props: {
    description: {
      type: String,
      default: ''
    }
  }
}
